<template>
  <div
    :class="[
      'item',
      {
        isOther: isOthers(item),
        active: isActive(item),
        inActive: isInactive(item),
      },
    ]"
    @click="$emit('toggleItem', item, true)"
  >
    <div class="item--rank">
      {{ item.RANK }}
    </div>
    <div class="item--label">
      <span class="value">{{ item["QTY%"] + "%" }}</span>
      <span class="country">{{ countryLabel(item) }}</span>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "ListItemClassification",
  props: {
    item: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      hoverId: null,
    };
  },
  computed: {
    ...mapGetters({
      selectedCountryId: "ui/selectedCountryId",
    }),
  },
  methods: {
    isOthers(item) {
      return (
        item.COUNTRY.toLowerCase() === "others" ||
        item.COUNTRY === "Rest of the World"
      );
    },
    countryLabel(item) {
      //[NB] QUI DA MOCKUP CI ANDREBBE REST OF THE WORLD MA NON è SEMPRE VERO, SE HO SELEZIONATO GEO AREA DOVREBBE ESSERCI REST OF THE EUROPE PER ESEMPIO
      // PER ORA LASCIO OTHERS PER TUTTI I CASI POI VEDREMO
      return this.isOthers(item) ? "Others: " : item.COUNTRY;
    },
    onTapItem(item, active) {
      // disable  hover for others
      if (this.isOthers(item)) {
        return;
      }
      this.hoverId = active ? item.GEO.id : null;
      this.setSelectedCountryId(this.hoverId);
    },
    isActive(item) {
      return this.hoverId !== null && this.hoverId === item.GEO.id;
    },
    isInactive(item) {
      return this.hoverId !== null && this.hoverId !== item.GEO.id;
    },
    ...mapActions({
      setSelectedCountryId: "ui/setSelectedCountryId",
    }),
  },
  watch: {
    selectedCountryId(newVal) {
      // console.log("newVal", newVal);
      this.hoverId = newVal;
    },
  },
};
</script>

<style lang="scss" scoped>
.item {
  width: 100%;
  height: 5.54vh;
  background-color: rgba(255, 255, 255, 0.05);
  display: flex;
  align-items: center;
  border-bottom: $white-border;
  transition: background-color 0.2s ease;

  &.active {
    border-top: $white-border;
  }

  &--label {
    padding: 0 toRem(13);
    .value {
      @include number-S;
      margin-right: toRem(4);
      color: $primary-yellow;
    }

    .country {
      @include dida-S;
      color: $ui-white;
    }

    .isOther & {
      display: flex;
      flex-direction: row-reverse;
      opacity: 0.7;
      .value {
        color: $ui-white;
        @include dida-S;
        margin: 0 5px;
      }
    }
  }

  &--rank {
    @include title-H6;
    width: toRem(63);
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    border-right: $white-border;

    .isOther & {
      display: none;
    }
  }

  &.active {
    background-color: var(--white_01);
  }

  &.inActive {
    opacity: 0.2;
  }
  &.isOther {
    height: 8.55vh;
  }
}

.tablet {
  .item {
    height: 100%;

    &.isOther {
      min-height: 3.57vh;
    }
  }
}
</style>
